export default {"src":"/_next/static/media/ticket-mobile.941ed5e4.svg","height":194,"width":954,"blurWidth":0,"blurHeight":0};